<cart class="cart cart-mobile" [disabled]="!isOpenForDelivery" (cartSubmit)="onCartSubmit()"></cart>
